import React from 'react';

export interface CardHeaderProps {
  title?: string;
  subtitle?: string;
  actions?: React.ReactNode;
  border?: boolean;
  className?: string;
}

const CardHeader: React.FC<CardHeaderProps> = ({
  title,
  subtitle,
  actions,
  border = false,
  className = '',
}) => {
  if (!title && !subtitle && !actions) return null;

  return (
    <div
      className={`flex items-center justify-between ${border ? 'border-b border-gray-200 pb-4 mb-6' : 'mb-4'} ${className}`}
    >
      <div className="flex-1">
        {title && <h3 className="text-lg onyx-subtitle text-onyx-dark-blue">{title}</h3>}
        {subtitle && <p className="text-sm text-gray-600 mt-1 onyx-body">{subtitle}</p>}
      </div>

      {actions && <div className="flex-shrink-0 ml-4">{actions}</div>}
    </div>
  );
};

export default CardHeader;
